import { useCacheRecord } from 'gossamer-front-end';
import { BookingPaymentTerms, EventExtendedView } from 'cb-model';

export function useEventPaymentData(eventId: number) {
  const eventRecord = useCacheRecord(EventExtendedView, eventId, !eventId);
  const termsId = eventRecord.data?.booking_payment_terms_id;
  const bookingPaymentTermsRecord = useCacheRecord(BookingPaymentTerms, String(termsId), !termsId);
  return { eventRecord, bookingPaymentTermsRecord };
}
